module.exports = __webpack_public_path__ + "static/media/bubble-tail-left.273b9c1e.svg";